function get(name) {
    const params = window.location.search;
    if ('URLSearchParams' in window) {
        return new URLSearchParams(params).get(name);
    }
    return getQueryParameterByRegex(params, name);
}

// Source:
// https://github.com/aframevr/aframe/blob/c606c25907bf5ad48cf8329ecd998fa48ff3a584/src/utils/index.js#L296
function getQueryParameterByRegex(params, name) {
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    const regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    const results = regex.exec(params);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

export const queryParameters = {
    get
};



// WEBPACK FOOTER //
// ./src/queryParameters.js